import {
  EffectiveOperationPermissionsArray,
  EffectiveOperationPermissionsMap,
} from '../types';

/**
 * Utility to convert EffectiveOperationPermissionsArray -->  EffectiveOperationPermissionsMap
 */
export function mapFromArray(
  permissions: EffectiveOperationPermissionsArray
): EffectiveOperationPermissionsMap {
  return permissions.reduce<EffectiveOperationPermissionsMap>(
    (accumulator, [operationName, operationPermission]) => {
      accumulator[operationName] = operationPermission;
      return accumulator;
    },
    {} as EffectiveOperationPermissionsMap
  );
}
